export default "__VITE_ASSET__DmwRo344__"